/**
 * Default FAQ items for Outfame.
 * Extracted to a separate module so both the FAQ client component
 * and server components (for JSON-LD generation) can import them.
 */

export interface FAQItem {
	question: string
	answer: string
}

export const DEFAULT_FAQ_ITEMS: FAQItem[] = [
	{
		question: "How fast will I see results?",
		answer: "Most users see new followers within 24-48 hours. Real growth usually kicks in within the first week. <a href='https://support.outfame.com/en/articles/13584995-the-learning-phase-explained' target='_blank' rel='noopener noreferrer' class='underline underline-offset-2 hover:text-black/80'>Learn more</a>"
	},
	{
		question: "Is my account safe?",
		answer: "Yes. We never ask for your password. We use Instagram's official APIs. 65,000+ accounts trust us. <a href='https://support.outfame.com/en/articles/13585010-is-outfame-safe' target='_blank' rel='noopener noreferrer' class='underline underline-offset-2 hover:text-black/80'>Learn more</a>"
	},
	{
		question: "Are these real followers or bots?",
		answer: "100% real people. Our AI finds users who match your niche and actually want to engage. No bots, ever. <a href='https://support.outfame.com/en/articles/13585005-are-the-followers-real' target='_blank' rel='noopener noreferrer' class='underline underline-offset-2 hover:text-black/80'>Learn more</a>"
	},
	{
		question: "Can I cancel anytime?",
		answer: "Yes. Just message our support team via live chat or email and we'll cancel your subscription—no contracts, no hidden fees. <a href='https://support.outfame.com/en/articles/13585038-cancellations-and-refunds' target='_blank' rel='noopener noreferrer' class='underline underline-offset-2 hover:text-black/80'>Learn more</a>"
	},
	{
		question: "What makes Outfame different from other growth services?",
		answer: "Most services deliver bots or get you flagged. We use AI to find real people who actually want to follow you—and we never touch your password. <a href='https://support.outfame.com/en/articles/13584978-how-outfame-works' target='_blank' rel='noopener noreferrer' class='underline underline-offset-2 hover:text-black/80'>Learn more</a>"
	},
	{
		question: "Does it work for any type of account?",
		answer: "Yes. Fitness, fashion, food, business—our AI adapts to find your perfect audience in any niche."
	}
]
